<template>
    <div id="userApps">
        <div class="col-lg-12 col-md-12 col-sm-12">
            <div class="body">
                <h4>템플릿</h4>

                <div  v-if="tempalteList.length > 0" class="table-responsive">
                    <table class="table" id="appsTabl">
                        <thead>
                        <tr>
                            <th>#</th>
                            <th>템플릿명</th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody >
                        <tr v-for="(temp, index) in tempalteList" v-bind:key="index">
                            <td>{{ index + 1 }}</td>
                            <td>{{ temp.workflowName }}</td>
                            <td>
                                <div>
                                    <button @click="duplicateWorkflow(index)" class="btn btn-primary" style="margin: 3px">워크플로우로 생성</button>
                                    <button @click="undoTemplate(index)" class="btn btn-warning" style="margin: 3px">템플릿에서 제거</button>
                                    <!--                  <button class="btn btn-danger" style="margin: 3px">삭제</button>-->
                                </div>
                            </td>
                        </tr>

                        </tbody>

                    </table>
                </div>
                <div v-if="tempalteList.length == 0">
                    템플릿이 없습니다.
                </div>

                <div style="text-align: center;">
                    <button type="button" class="btn btn-primary " v-if="this.skipNum > 0" @click="getPreviousPage">이전</button>
                    <span v-for="num in Math.ceil(this.totalCount/this.pageNum)" :key="num">

              <button class="btn" v-if="num != skipNum + 1 && num < skipNum + 4 && num > skipNum - 4"  style="color: forestgreen" @click="skipToPage(num)">{{ num }}</button>
              <button type="button" class="btn" v-if="num == skipNum + 1" style="color: #00dd3a" @click="skipToPage(num)">{{ num }}</button>
        </span>
                    <!--{{Math.floor(this.totalCount/this.pageNum)}}-->
                    <button type="button" class="btn btn-primary " v-if="this.tempalteList.length == 20 && this.pageNum * this.skipNum + 20 < this.totalCount" @click="getNextPage">다음</button>

                </div>
            </div>

        </div>
    </div>
</template>


<script>
export default {
    name: 'TemplatePage',
    components: {
    },
    data() {
        return {
            tempalteList: null,
            pageNum : 20,
            skipNum : 0,
            totalCount : 0,

            planName : null,
            planType : null,
            flowCount : 0,
            flowTotal : 0,
            workCount : 0,
            workTotal : 0,
            leadCount : 0,
            leadTotal : 0,
        }
    },
    methods: {
        skipToPage(num) {
            this.skipNum = num-1;

            this.getTempList();

        },
        countingIndex(index) {

            return this.skipNum * this.pageNum + index + 1;


        },
        getPreviousPage() {
            this.skipNum = this.skipNum - 1;

            this.getTempList();
        },
        getNextPage() {
            this.skipNum = this.skipNum + 1;

            this.getTempList();

        },
        duplicateWorkflow(index){

            // if(this.flowCount == this.flowTotal || this.flowCount > this.flowTotal ){
            //     alert("생성 가능한 최대 갯수에 도달하였습니다.")
            // } else {
                if(confirm("워크플로우로 생성하시겠습니까?")){
                    var param = {
                        workflowCode : this.tempalteList[index].workflowCode,
                        userCode : this.$store.getters.getUserCode

                    }

                    this.api.duplicateWorkflow(param)
                        .then((res)=>{
                            if(res.code == 0){
                                alert("생성이 완료되었습니다.");
                                this.getTasks();
                            }
                        })

                }
            // }

            console.log(this.tempalteList[index].workflowCode)

        },
        undoTemplate(index){
            var status = 'N';
            var korean = '비적용';

            korean = '비적용'

            if(confirm('템플릿에 ' + korean +'으로 변경하시겠습니까? 만약 워크플로우가 삭제된 상태면 복구할 수 없을 수 있습니다.')){
                console.log(index)

                var param = {
                    workflowCode : this.tempalteList[index].workflowCode,
                    setAsTemplate :status
                }

                this.api.setTemplate(param)
                    .then((res)=>{
                        console.log(res);

                        this.getTempList()

                    })
            }
        },
        getTempList(){
            var param = {
                userCode: this.$store.state.userStore.userCode,
                pageNum : this.pageNum,
                skipNum : this.skipNum
            }

            this.api.getTemplate(param)
                .then((res) => {

                    this.totalCount = res.totalCount;

                    console.log(res.list.length, "/0", Object.keys(res.list).length)

                    this.tempalteList = res.list;

                    this.getTasks();


                })
        },
        getTasks(){
            this.api.getUserTask({
                companyCode : this.$store.state.userStore.userCode,
                dateOfSearch : null,
                siteCode : this.$store.state.userStore.siteCode
            })
                .then((res) => {

                    if(this.utils.preApiHandle(res)) {
                        console.log("profile create res : ", res)
                    }

                    console.log(res)
                    if (res.code == 0) {
                        console.log(res);
                        this.planName = res.task.planName
                        this.flowCount = res.task.flowCount
                        this.flowTotal = res.task.flowTotal
                        this.workCount = res.task.workCount
                        this.workTotal = res.task.workTotal
                        this.leadCount = res.task.leadCount
                        this.leadTotal = res.task.leadTotal
                        this.planType = res.task.planName

                        if(res.status == "N"){
                            alert("플랜기간이 만기했습니다.");
                            this.$router.push({name:'ProfilePage'})
                        }

                    } else {

                        alert("오류가 발생했습니다.");
                        // location.href="/";
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
    },
    created() {
        console.log('TemplatePage created')
        this.getTempList();
    },
    mounted() {
        console.log('TemplatePage created')
    },
    beforeDestroy() {
        console.log('TemplatePage beforeDestroy')
    }
}
</script>
<style scoped>
#userApps {
    padding: 10px;
}

#appsTabl {
    text-align: center;
}
</style>
